import React, { useState, useEffect } from "react";
import ConfLeftPanel from "./authConf/confLeftPanel";
import SignInComponent from "./authConf/signInComponent";
import Guest from "./authConf/Guest";
import { useNavigate } from "react-router-dom";
import { useWhiteLabel } from "../../context/WhiteLabelContext";
import RLinkLogo from "../common/RLinkLogo";

const Login = () => {
  const navigate = useNavigate();
  const [guest, setGuest] = useState(false);
  const [show, setShow] = useState(false);
  const { branding, loading: whiteLabelLoading } = useWhiteLabel();

  useEffect(() => {
    const roomId = localStorage.getItem("roomId");
    console.log("roomId", roomId);
    if (roomId) {
      setGuest(true);
    }
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    } else {
      setShow(true);
    }
  }, []);

  // Don't render until whitelabel loading is complete to prevent logo flash
  if (whiteLabelLoading) {
    return (
      <div className="w-full min-h-screen bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)]" />
    );
  }

  return (
    <>
      {show && <div className="w-full min-h-screen  bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)]">
        <div className="py-4 border-b border-slate-700 flex items-center justify-between">
          <div className="ml-3">
            <RLinkLogo size="md" companyLogo={branding.companyLogo} companyName={branding.companyName} />
          </div>
          <div className="flex items-center gap-2 mr-4"></div>
        </div>
        <div className="flex justify-center h-[90vh] w-full pt-[1%]">
          <div className="sm:w-[90%] md:w-[80%] sm:rounded-2xl md:rounded-4xl overflow-hidden flex flex-col lg:flex-row">
            <ConfLeftPanel />
            {!guest && <SignInComponent />}
            {guest && <Guest onHostsLoginClick={() => setGuest(false)} />}

            {/* <SignInComponent /> */}
          </div>
        </div>
      </div>}
    </>
  );
};

export default Login;
